<div id="address-filters">
  <div class="row">
    <p class="title">Endereço padrão</p>
    <a class="clean-filters">Limpar</a>
  </div>

  <lib-button-tertiary (click)="showModal=true">Adicionar</lib-button-tertiary>
</div>

<div class="modal" *ngIf="showModal == true">
  
  <div class="bg" (click)="showModal=false"></div>
  
  <div class="content">
    <div class="row">
      <p class="title">Filtro de endereço completo</p>
      <a class="close" (click)="showModal=false">&times;</a>
    </div>
    <div class="row">
      <app-input class="four-fifth" id="logradouro" label="Logradouro" placeholder="">
      </app-input>
      <app-input class="one-fifth" id="numero" label="Número" placeholder="">
      </app-input>
    </div>
    <div class="row">
      <app-input class="one-third" id="bairro" label="Bairro" placeholder="">
      </app-input>
      <app-input class="one-third" id="cidade" label="Cidade" placeholder="">
      </app-input>
      <app-input class="one-third" id="estado" label="Estado" placeholder="">
      </app-input>
    </div>
    <div class="row">
      <app-input class="one-third" id="torre" label="Torre" placeholder="">
      </app-input>
      <app-input class="one-third" id="andar" label="Andar" placeholder="">
      </app-input>
      <app-input class="one-third" id="unidade" label="Unidade" placeholder="">
      </app-input>
    </div>

    <div class="row buttons">
      <lib-button-tertiary  (click)="showModal=false">Cancelar</lib-button-tertiary>
      <lib-button-primary>Adicionar</lib-button-primary>
    </div>
  </div>
</div>